exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort-drdn-arrow-icon[data-v-30f703e2]{font-size:16px;cursor:pointer}", ""]);

// exports
